import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-01/task-01";

const task: Slide = {
  titleHtml:
    "A piston in an infinite tube vibrates with an amplitude e = 1 mm at 100 Hz. What are the amplitudes of the acoustic<br>particle velocity, acceleration and pressure?",
  description: "Select the correct answer(s).",
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 3,
      colSpan: {
        "1:0": 3,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                    <mi>v</mi>
                  </math>
                  =`,
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "24px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                    <mi>a</mi>
                  </math>
                  =`,
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "24px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                    <mi>p</mi>
                  </math>
                  =`,
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "24px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
        [],
      ],
    },
  },
};

export default task;
